import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import find from "lodash/find";
import { Button, ImageList, ImageListItem, Backdrop, Box } from "@mui/material";
import axios from "axios";

import SideNav from "../../components/SideNav";
import { makeUrl } from "../../services/api";

import "../Home/styles.scss";

function Projects() {
  const params = useParams();
  const [error, setError] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  useEffect(() => {
    if (projects) {
      const projectData = find(projects, { title: params.nav });
      setSelectedProject(projectData);

      const element = document.getElementById("description-wrapper");
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [params.nav, projects]);

  useEffect(() => {
    axios
      .get(makeUrl("/projects"))
      .then(({ data }) => {
        const sortedData = data
          .filter(project => !!project.published_at)
          .map((project) => {
            project.timestamp = new Date(project.projectDate).getTime();
            return project;
          })
          .sort((a, b) => b.timestamp - a.timestamp);
        console.log(sortedData);
        setProjects(sortedData);
      })

      .catch((error) => setError(error));
  }, []);

  function makeMenu(item) {
    item.link = `/projects/${encodeURIComponent(item.title)}`;
    return item;
  }

  return (
    <div className="App">
      <Backdrop
        sx={{ background: "rgba(0,0,0,.90)", zIndex: 9999 }}
        open={open}
        onClick={handleClose}
      >
        {selectedProject?.VideoURL && (
          <iframe
            id="myframe"
            title="vimeo-player"
            src={`${selectedProject?.VideoURL}&playsinline=0`}
            style={{
              display: "flex",
              width: "100vw",
              maxHeight: "70vh",
              height: "100%",
            }}
            frameborder="0"
            allowscriptaccess="always"
            allowFullScreen="true"
          ></iframe>
        )}
      </Backdrop>
      <Grid container>
        <Grid item xs={12} md={3}>
          {projects && projects.length ? (
            <SideNav menu={projects.map(makeMenu)} back="/home" />
          ) : null}
        </Grid>
        <Grid
          item
          xs={12}
          md={7}
          style={{ marginTop: "20px" }}
          id="description-wrapper"
        >
          {selectedProject?.stills.length > 0 && (
            <img
              src={selectedProject?.stills[0].url}
              loading="lazy"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
          {selectedProject?.title && <h1>{selectedProject?.title}</h1>}
          {selectedProject?.description && (
            <div className="description">{selectedProject?.description}</div>
          )}
          {selectedProject?.VideoURL && (
            <>{renderVideo(selectedProject?.VideoURL, handleToggle)}</>
          )}
          <ImageList variant="masonry" cols={1} gap={20}>
            {selectedProject?.stills
              .slice(1, selectedProject?.stills.length - 1)
              .map((still) => (
                <ImageListItem>
                  <img src={still.url} loading="lazy" />
                </ImageListItem>
              ))}
          </ImageList>
        </Grid>
      </Grid>
    </div>
  );
}

const isYT = (url) => {
  return url.includes("youtube");
};

// function that renders video iframe html if the url is a youtube url
function renderVideo(url, handleToggle) {
  if (isYT(url)) {
    return <div dangerouslySetInnerHTML={{ __html: url }} />;
  } else {
    return (
      <>
        <Box
          onClick={() => handleToggle()}
          sx={{
            width: "100%",
            height: "540px",
            position: "relative",
            marginBottom: "-600px",
            cursor: "pointer",
          }}
        />
        <iframe
          src={`${url}&playsinline=0`}
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          style={{ display: "flex", width: "100%", minHeight: "600px" }}
        ></iframe>
      </>
    );
  }
}

export default Projects;
